export const BLOCKQUOTE = {
  'padding-left': '1em',
  'border-left': '3px solid #eee',
  'margin-left': '0',
  'margin-right': '0'
};
export const PRE = {
  'white-space': 'pre-wrap',
  'background-color': '#f7f7f7',
  'padding': '1em 2em'
};
export const CODE = {
  'font-family': 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace'
};
export const HEADER = {
  'margin-top': '0',
  'margin-bottom': '0.5em',
  color: 'rgba(0, 0, 0, 0.85)',
  'font-weight': '500'
};
export const PARA = {
  'marginTop': '0.36em',
  'marginBottom': '0.36em',
  'lineHeight': '1.43em',
  'minHeight': '1.43em'
};
export const IMAGE = {
  'default': {
    'max-width': '100%'
  },
  'align-left': {
    'max-width': '40%',
    display: 'block'
  },
  'align-center': {
    'max-width': '40%',
    display: 'block',
    margin: 'auto'
  },
  'align-right': {
    'max-width': '40%',
    display: 'block',
    margin: '0 0 0 auto'
  },
  'wrap-left': {
    'max-width': '40%',
    float: 'left',
    'margin-right': '0.98em'
  },
  'wrap-right': {
    'max-width': '40%',
    float: 'right',
    'margin-left': '0.98em'
  }
};
export const LAYOUT_COLUMN = {
  'min-height': '10em',
  border: '1px solid #ccc',
  margin: '0.7em',
  'border-radius': '0.7em'
};
export const LAYOUT_COLUMN_CONTENT = {
  height: '100%',
  padding: '0.7em'
};
export const LAYOUT_SECTION = {
  display: 'flex',
  'flex-direction': 'row'
};
export const ANCHOR = {
  color: '#1890ff',
  'text-decoration': 'none',
  'background-color': 'transparent',
  outline: 'none',
  cursor: 'pointer'
};
export const MENTION = {
  color: '#14aaf5',
  cursor: 'pointer',
  'font-weight': '600'
};
export const TABLE_BASE_STYLES = {
  table: {
    'border-collapse': 'collapse',
    'table-layout': 'fixed',
    border: '1px solid black',
    'overflow': 'hidden',
    'margin': '1.4em',
    'min-width': '75px'
  },
  tableCell: {
    'verticalAlign': 'top',
    'boxSizing': 'border-box',
    'position': 'relative',
    'padding': '0 1.4em',
    'minHeight': '1.3em',
    border: '1px solid black'
  },
  tableHeading: {
    'verticalAlign': 'top',
    'boxSizing': 'border-box',
    'position': 'relative',
    'padding': '0 1.4em',
    'minHeight': '1.3em',
    'backgroundColor': '#ddd',
    border: '1px solid black'
  },
  'align-left': {
    margin: '1.4em'
  },
  'align-center': {
    margin: '1.4em auto'
  },
  'align-right': {
    'margin-left': 'auto'
  }
};